import { createAction, createSlice } from '@reduxjs/toolkit';
import get from 'lodash/get';
import set from 'lodash/set';
import filter from 'lodash/filter';

export const getMasterOrders = createAction('rxOrders/getMasterOrders');
export const createPatientOrder = createAction('rxOrders/createPatientOrder');
export const updatePatientOrderById = createAction('rxOrders/updatePatientOrderById');
export const getPatientOrdersById = createAction('rxOrders/getPatientOrdersById');
export const getPatientDiagnosisById = createAction('rxOrders/getPatientDiagnosisById');
export const geAppointmentOrdersById = createAction('rxOrders/geAppointmentOrdersById');

const rxOrderSlice = createSlice({
  name: 'RxOrder',
  initialState: {
    masterOrders: [],
    activeOrder: [],
    newOrders: [],
    appointmentDiagnosisList: [],
    activePatientOrders: [],
    activeAppointmentOrders: [],
    orderStep: 0,
  },
  reducers: {
    getMasterOrdersSuccess(state, action) {
      state.masterOrders = action.payload.data;
    },
    getPatientOrdersByIdSuccess(state, action) {
      const { data } = action.payload;
      state.activePatientOrders = data;
    },
    getPatientDiagnosisByIdSuccess(state, action) {
      const { data } = action.payload;
      state.appointmentDiagnosisList = data;
    },
    geAppointmentOrdersByIdSuccess(state, action) {
      const { data } = action.payload;
      state.activeAppointmentOrders = data;
    },
    addNewOrders(state, action) {
      const { data } = action.payload;
      state.newOrders.push(...data);
    },
    deleteOrder(state, action) {
      const { orderItemId } = action.payload;
      state.newOrders = state.newOrders.filter(order => order.orderItemId !== orderItemId);
    },
    onChangeOrdersValue(state, action) {
      const { name, value, type, checked, orderItemId } = action.payload;
      const order = state.newOrders.filter(a => a.orderItemId === orderItemId);
      if (name === 'zeroIndex-description') {
        set(order, '[0].diagnoses[0].description', value);
      } else if (name.split('-')[0] === 'diagnosis') {
        if (checked) {
          const diag = filter(state.appointmentDiagnosisList, { icd10Code: name.split('-')[1] });
          order[0].diagnoses.push(...diag);
        } else {
          order[0].diagnoses = filter(order[0].diagnoses, a => a.icd10Code !== name.split('-')[1]);
        }
      } else {
        set(order, `[0][${name}]`, type === 'checkbox' ? checked : value);
      }
    },
    handleNextOrderStep(state) {
      state.orderStep += 1;
    },
    handlePreviousOrderStep(state) {
      state.orderStep -= 1;
    },
    resetRxOrderValues(state, action) {
      state.newOrders = [];
      state.orderStep = 0;
    },
    populateOrderFromChartImport(state, action) {
      const { data } = action.payload;
      state.newOrders = data;
    },
    markOrderForDeletion(state, action) {
      const { orderItemId } = action.payload;
      state.newOrders = state.newOrders.map(order => {
        if (order.orderItemId === orderItemId) {
          return { ...order, markForDeletion: true };
        }
        return order;
      });
    },
  },
});

export const {
  getMasterOrdersSuccess,
  getPatientOrdersByIdSuccess,
  getPatientDiagnosisByIdSuccess,
  addNewOrders,
  deleteOrder,
  onChangeOrdersValue,
  geAppointmentOrdersByIdSuccess,
  handleNextOrderStep,
  handlePreviousOrderStep,
  resetRxOrderValues,
  populateOrderFromChartImport,
  markOrderForDeletion,
} = rxOrderSlice.actions;

export default rxOrderSlice.reducer;
